/* eslint-disable no-unused-vars */
import { axios } from './index'

const resource = '/v1/stay'

export default {
  async getMenuBasicInfo(menuNo) {
    return axios.get(`${resource}/menu/${menuNo}`)
  },
  async getDPMenuBasicInfo(menuNo) {
    return axios.get(`${resource}/dp/menus/${menuNo}`)
  },
  async getMenuStay(menuNo, params = {}) {
    return axios.get(`${resource}/menu/${menuNo}/stay`, { params })
  },
  async getFacilities(params = {}) {
    // facilities/{latitude}/{longitude}?count=xyz&startIndex=xyz
    const queryParams = {
      count: params.pageSize ? params.pageSize : 10,
      startIndex: params.page ? +params.page - 1 : 0
    }
    return axios.get(
      `${resource}/menu/facilities/${params.latitude}/${params.longitude}`,
      { params: queryParams }
    )
  },
  async getSameCategoryMenus(queryParams = {}) {
    return axios.get(`${resource}/menu`, {
      params: {
        catLrgClassCd: queryParams.catLrgClassCd ? queryParams.catLrgClassCd : '',
        catMidClassCd: queryParams.catMidClassCd ? queryParams.catMidClassCd : '',
        catSmlClassCd: queryParams.catSmlClassCd ? queryParams.catSmlClassCd : '',
        count: queryParams.pageSize ? queryParams.pageSize : 10,
        startIndex: queryParams.page ? queryParams.page - 1 : 0
      }
    })
  },
  async getPhotoGallery(menuNo) {
    return axios.get(`${resource}/menu/${menuNo}/images`)
  },
  getFavourite(params) {
    return new Promise((resolve) => {
      axios.get(`${resource}/menu/favourite`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        () => {
          resolve({})
        }
      )
    })
  },

  getVacancyCalendar(body) {
    return new Promise((resolve) => {
      axios.post(`${resource}/search/date/available`, body).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          resolve(error)
        }
      )
    })
  },

  getRakutenInformation(rakutenHotelNo) {
    const params = {
      hotelNo: rakutenHotelNo
    };

    return new Promise((resolve) => {
      axios.get(`${resource}/menu/hotel-information-rakuten`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          resolve(error)
        }
      )
    });
  },
 
}
